import React, { useState, useEffect } from 'react';

import 'react-toastify/dist/ReactToastify.css';

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { get } from 'lodash';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { TabView, TabPanel } from 'primereact/tabview';

import * as actions from '../../../store/modules/auth/actions';

import { displayErrors } from '../../../util/diversos';
import { Input100px, Input155px } from '../../../styles/inputGroup';

import Card from '../../../components/card';
import store from '../../../store/store';
import axiosAdmin from '../../../services/axiosAdmin';
import Loading from '../../loading';

import { obterListaMdfeTipoRodado } from '../../../services/mdfeTipoRodado';
import { obterListaMdfeTipoCarroceria } from '../../../services/mdfeTipoCarroceria';
import { obterListaMdfeTipoProprietario } from '../../../services/mdfeTipoProprietario';

import ConsultaParticipante from '../participante/consultaParticipante';
import ConsultaMotorista from '../motorista/consultaMotorista';

import { obterListaTipoCombustivel } from '../../../services/tipoCombustivel';
import { obterListaTipoPintura } from '../../../services/tipoPintura';
import { obterListaTipoVeiculo } from '../../../services/tipoVeiculo';
import { obterListaEspecieVeiculo } from '../../../services/especieVeiculo';
import { obterListaCodigoCorDenatran } from '../../../services/codigoCorDenatran';
import { obterListaTipoRestricao } from '../../../services/tipoRestricao';

export default function CadastroVeiculo({ payloadCadastro, childToParentConsulta }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const id = get(payloadCadastro, 'id', 0);

  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [placa, setPlaca] = useState('');
  const [idParticipante, setIdParticipante] = useState('');
  const [nomeParticipante, setNomeParticipante] = useState('');
  const [idMotorista, setIdMotorista] = useState('');
  const [nomeMotorista, setNomeMotorista] = useState('');
  const [renavan, setRenavan] = useState('');
  const [tara, setTara] = useState(0);
  const [capKg, setCapKg] = useState(0);
  const [capM3, setCapM3] = useState(0);
  const [uf, setUf] = useState('');
  const [listaUf, setListaUf] = useState([]);
  const [tipoRodado, setTipoRodado] = useState('TRUCK');
  const [tipoCarroceria, setTipoCarroceria] = useState('NAOAPLICAVEL');

  // especificacoes: dados veiculo para nota de revenda de carro
  const [cor, setCor] = useState('');
  const [chassi, setChassi] = useState('');
  const [codigoCor, setCodigoCor] = useState('');
  const [potenciaCv, setPotenciaCv] = useState(0);
  const [cilindradas, setCilindradas] = useState(0);
  const [nSerie, setNSerie] = useState('');
  const [pesoB, setPesoB] = useState(0);
  const [pesoL, setPesoL] = useState(0);
  const [tpComb, setTpComb] = useState('GASOLINA');
  const listaTipoCombustivel = obterListaTipoCombustivel();
  const [nMotor, setNMotor] = useState('');
  const [cmt, setCmt] = useState(0);
  const [dist, setDist] = useState(0);
  const [anoModelo, setAnoModelo] = useState(0);
  const [anoFabricacao, setAnoFabricacao] = useState(0);
  const listaTipoPintura = obterListaTipoPintura();
  const [tpPint, setTpPint] = useState('SOLIDA');
  const listaTipoVeiculo = obterListaTipoVeiculo();
  const [tpVeic, setTpVeic] = useState('AUTOMOVEL');
  const listaEspecieVeiculo = obterListaEspecieVeiculo();
  const [espVeic, setEspVeic] = useState('PASSAGEIRO');
  const [listaVin] = useState([ // remarcado ou normal
    { label: 'Normal', value: 'N' },
    { label: 'Remarcado', value: 'R' },
  ]);
  const [vin, setVin] = useState('N');
  const [listaCondicaoVeiculo] = useState([ // remarcado ou normal
    { label: 'Acabado', value: '1' },
    { label: 'Inacabado', value: '2' },
    { label: 'Semi-acabado', value: '3' },
  ]);
  const [condVeic, setCondVeic] = useState('1');
  const [cMod, setCMod] = useState('');
  const listaCodigoCorDenatran = obterListaCodigoCorDenatran();
  const [cCorDenatran, setCCorDenatran] = useState('BRANCA');
  const [lota, setLota] = useState(0);
  const listaTipoRestricao = obterListaTipoRestricao();
  const [tpRest, setTpRest] = useState('NAOHA');

  const [proprietarioNome, setProprietarioNome] = useState('');
  const [proprietarioCnpj, setProprietarioCnpj] = useState('');
  const [proprietarioIe, setProprietarioIe] = useState('');
  const [proprietarioRntrc, setProprietarioRntrc] = useState('');
  const [proprietarioUf, setProprietarioUf] = useState('');
  const [proprietarioTipo, setProprietarioTipo] = useState('');

  const listaMdfeTipoRodado = obterListaMdfeTipoRodado();
  const listaMdfeTipoCarroceria = obterListaMdfeTipoCarroceria();
  const listaMdfeTipoProprietario = obterListaMdfeTipoProprietario();

  const [showConsultaParticipante, setShowConsultaParticipante] = useState(false);
  const [showConsultaMotorista, setShowConsultaMotorista] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let newTitle = 'Veículo - Cadastro';
    if (id) {
      newTitle = 'Veículo - Edição';
    }

    dispatch(actions.titleHeaderChange({ newTitle }));

    if (!id) return;

    async function getData() {
      try {
        setIsLoading(true);

        const { data } = await axiosAdmin.get(`/veiculo/${id}`);

        console.log('data: ', data);

        const idUsuario = get(store.getState().auth.user, 'id', 0);
        if (data.idUsuario !== idUsuario) {
          navigate('/consultaveiculo');
          toast.error('Acesso negado');
        }

        setPlaca(data.placa);
        if (data.participante) {
          setIdParticipante(data.participante.id);
          setNomeParticipante(data.participante.razaoSocial);
        }

        if (data.motorista) {
          setIdMotorista(data.motorista.id);
          setNomeMotorista(data.motorista.nome);
        }
        setRenavan(data.renavan);
        setCapKg(data.capKg);
        setCapM3(data.capM3);
        setTara(data.tara);
        setUf(data.uf);
        setTipoRodado(data.tpRod);
        setTipoCarroceria(data.tpCar);
        setProprietarioNome(data.propNome);
        setProprietarioCnpj(data.propCnpj);
        setProprietarioIe(data.propIe);
        setProprietarioRntrc(data.propRntrc);
        setProprietarioTipo(data.propTipo);
        setProprietarioUf(data.propUf);

        // especificacoes
        setCor(data.cor);
        setChassi(data.chassi.trim());
        setCodigoCor(data.codigoCor.trim());
        setPotenciaCv(data.potenciaCv ? data.potenciaCv : 0);
        setCilindradas(data.cilindradas ? data.cilindradas : 0);
        setNSerie(data.nserie);
        setPesoB(data.pesoB);
        setPesoL(data.pesoL);
        setTpComb(data.tpComb);
        setNMotor(data.nmotor);
        setCmt(data.cmt);
        setDist(data.dist);
        setAnoModelo(data.anoModelo);
        setAnoFabricacao(data.anoFabricacao);
        setTpPint(data.tpPint);
        setTpVeic(data.tpVeic);
        setVin(data.vin);
        setEspVeic(data.espVeic);
        setCondVeic(data.condVeic);
        setCMod(data.cmod);
        setCCorDenatran(data.ccorDenatran);
        setLota(data.lota);
        setTpRest(data.tpRest);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }

    getData();
  }, [dispatch, id, navigate]);

  useEffect(() => {
    let mostrarMensagemErro = true;

    async function getUnidadesFederacao() {
      try {
        setIsLoading(true);

        const listDropdown = [];

        const { data: ufs } = await axiosAdmin.get('/unidadefederacao');

        ufs.forEach(element => {
          listDropdown.push({ label: element.sigla, value: element.sigla });
        });

        listDropdown.sort((a, b) => ((a.label > b.label) ? 1 : -1));

        setListaUf(listDropdown);
      } catch (err) {
        if (mostrarMensagemErro) {
          displayErrors(err, dispatch, navigate, '/', '');
        }
        mostrarMensagemErro = false;
      } finally {
        setIsLoading(false);
      }
    }

    getUnidadesFederacao();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function salvarRegistro() {
    try {
      setIsLoading(true);

      const idUsuario = get(store.getState().auth.user, 'id', 0);

      const cnpjEmpresa = get(payloadCadastro, 'cnpjEmpresa', '');

      const shippingData = {
        idUsuario,
        cnpjEmpresa,
        placa: placa.toUpperCase(),
        idParticipante,
        idMotorista,
        renavan,
        capKg,
        capM3,
        tara,
        uf,
        tpRod: tipoRodado,
        tpCar: tipoCarroceria,
        propNome: proprietarioNome,
        propRntrc: proprietarioRntrc,
        propCnpj: proprietarioCnpj,
        propIe: proprietarioIe,
        propUf: proprietarioUf,
        propTipo: proprietarioTipo,
        cor,
        chassi,
        codigoCor,
        potenciaCv,
        cilindradas,
        nSerie,
        pesoB,
        pesoL,
        tpComb,
        nMotor,
        cmt,
        dist,
        anoModelo,
        anoFabricacao,
        tpPint,
        tpVeic,
        vin,
        espVeic,
        condVeic,
        cMod,
        cCorDenatran,
        lota,
        tpRest,
      };

      console.log('shippingdata: ', shippingData);

      let payloadDataTableList = {};

      if (id > 0) {
        payloadDataTableList = get(await axiosAdmin.put(`/veiculo/${id}`, shippingData), 'data', {});
        toast.success('Veículo atualizado com sucesso');
      } else {
        payloadDataTableList = get(await axiosAdmin.post('/veiculo', shippingData), 'data', {});
        toast.success('Veículo cadastrado com sucesso');
      }

      childToParentConsulta(payloadDataTableList, id);
    } catch (err) {
      displayErrors(err, dispatch, navigate, '', 'Não foi possível atualizar o registro');
    } finally {
      setIsLoading(false);
    }
  }

  const handleCancel = () => {
    childToParentConsulta();
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let formErros = false;

    if (!placa) {
      formErros = true;
      toast.error('Placa deve ser informada');
    }

    if (!renavan || renavan.length < 9) {
      formErros = true;
      toast.error('Renavan deve ser informada');
    }

    if (uf.length < 2) {
      formErros = true;
      toast.error('UF deve ser informada');
    }

    if (capKg <= 0) {
      formErros = true;
      toast.error('Capacidade em kg deve ser informada');
    }

    if (tara <= 0) {
      formErros = true;
      toast.error('Tara em kg deve ser informada');
    }

    if (chassi && chassi.length < 17) {
      formErros = true;
      toast.error('Chassi deve conter 17 caracteres.');
    }

    if (formErros) return;

    salvarRegistro();
  };

  const childToParentParticipante = (e) => {
    const idElement = get(e, 'id', 0);

    if (idElement > 0) {
      if (e.id) {
        setIdParticipante(e.id);
      }
      if (e.razaoSocial) {
        setNomeParticipante(e.razaoSocial);
      }
      setShowConsultaParticipante(false);
    } else {
      toast.warning('Por favor, selecione o registro');
    }
  };

  const onHideConsultaParticipante = () => {
    setShowConsultaParticipante(false);
  };

  const limparParticipante = () => {
    setIdParticipante('');
    setNomeParticipante('');
  };

  const childToParentMotorista = (e) => {
    const idElement = get(e, 'id', 0);

    if (idElement > 0) {
      if (e.id) {
        setIdMotorista(e.id);
      }
      if (e.nome) {
        setNomeMotorista(e.nome);
      }
      setShowConsultaMotorista(false);
    } else {
      toast.warning('Por favor, selecione o registro');
    }
  };

  const onHideConsultaMotorista = () => {
    setShowConsultaMotorista(false);
  };

  const limparMotorista = () => {
    setIdMotorista('');
    setNomeMotorista('');
  };

  const titulo = () => (id ? 'Veículo - Alteração' : 'Veículo - Inclusão');

  const handleChassiChange = (e) => {
    // eslint-disable-next-line prefer-destructuring
    let value = e.target.value;

    value = value.toUpperCase();

    // 3. Regex para permitir apenas letras (A-H, J-N, P-Z) e números (0-9)
    // O ^ dentro dos colchetes com 'g' remove o que NÃO for permitido
    const somenteValidos = value.replace(/[^A-HJ-NP-Z0-9]/g, '');

    // 4. Atualiza o estado
    setChassi(somenteValidos);
  };

  return (
    <div>
      <Loading isLoading={isLoading} />

      <Dialog
        header="Consulta de Participante"
        visible={showConsultaParticipante}
        style={{ width: '98vw' }}
        onHide={() => onHideConsultaParticipante()}
      >
        <ConsultaParticipante menuMode={false} childToParent={childToParentParticipante} />
      </Dialog>

      <Dialog
        header="Consulta de Motorista"
        visible={showConsultaMotorista}
        style={{ width: '98vw' }}
        onHide={() => onHideConsultaMotorista()}
      >
        <ConsultaMotorista menuMode={false} childToParent={childToParentMotorista} />
      </Dialog>

      <Card>
        <div className="card mb-3">
          <h6 className="card-header" style={{ textAlign: 'center' }}>{titulo()}</h6>
        </div>
        <TabView activeIndex={activeTabIndex} onTabChange={(e) => setActiveTabIndex(e.index)}>
          <TabPanel header="Principal">
            <div className="row form-elo">
              <div className="col-3">
                <div className="p-inputgroup">
                  <Input100px className="p-inputgroup-addon">
                    Placa
                  </Input100px>
                  <InputText
                    autoFocus
                    maxLength={7}
                    value={placa}
                    onChange={e => setPlaca(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Renavan
                  </Input155px>
                  <InputText
                    minLength={9}
                    maxLength={11}
                    value={renavan}
                    onChange={e => setRenavan(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Capacidade em Kg
                  </Input155px>
                  <InputNumber
                    maxFractionDigits={0}
                    min={0}
                    max={999999}
                    value={capKg}
                    onValueChange={e => setCapKg(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Capacidade M3
                  </Input155px>
                  <InputNumber
                    maxFractionDigits={0}
                    min={0}
                    max={999}
                    value={capM3}
                    onValueChange={e => setCapM3(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="row form-elo">
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Motorista
                  </Input155px>
                  <Button
                    icon="pi pi-search"
                    className="p-button-warning"
                    onClick={() => setShowConsultaMotorista(true)}
                  />
                  <Button
                    icon="pi pi-trash"
                    className="p-button-danger"
                    onClick={() => limparMotorista()}
                  />
                  <InputText
                    disabled
                    maxLength={255}
                    value={nomeMotorista}
                  />
                </div>
              </div>
              <div className="col-8">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Cliente
                  </Input155px>
                  <Button
                    icon="pi pi-search"
                    className="p-button-warning"
                    onClick={() => setShowConsultaParticipante(true)}
                  />
                  <Button
                    icon="pi pi-trash"
                    className="p-button-danger"
                    onClick={() => limparParticipante()}
                  />
                  <InputText
                    disabled
                    maxLength={255}
                    value={nomeParticipante}
                  />
                </div>
              </div>
            </div>
            <div className="row form-elo">
              <div className="col-3">
                <div className="p-inputgroup">
                  <Input100px className="p-inputgroup-addon">
                    UF
                  </Input100px>
                  <Dropdown
                    options={listaUf}
                    value={uf}
                    emptyMessage="Nenhum registro a ser exibido"
                    onChange={e => setUf(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Tipo de Rodado
                  </Input155px>
                  <Dropdown
                    options={listaMdfeTipoRodado}
                    value={tipoRodado}
                    emptyMessage="Nenhum registro a ser exibido"
                    onChange={(e) => setTipoRodado(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Tipo de Carroceria
                  </Input155px>
                  <Dropdown
                    options={listaMdfeTipoCarroceria}
                    value={tipoCarroceria}
                    emptyMessage="Nenhum registro a ser exibido"
                    onChange={(e) => setTipoCarroceria(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Tara em kg
                  </Input155px>
                  <InputNumber
                    maxFractionDigits={0}
                    min={0}
                    max={999999}
                    value={tara}
                    onValueChange={e => setTara(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="row form-elo">
              <div className="col-12">
                <hr />
                <center> Dados do Proprietário do Veículo (Só preenchido quando o veículo não pertencer à empresa emitente do MDF-e) </center>
              </div>
            </div>
            <div className="row form-elo">
              <div className="col-6">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Nome do Proprietário
                  </Input155px>
                  <InputText
                    maxLength={60}
                    value={proprietarioNome}
                    onChange={e => setProprietarioNome(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="p-inputgroup">
                  <Input100px className="p-inputgroup-addon">
                    CNPJ/CPF
                  </Input100px>
                  <InputText
                    maxLength={14}
                    value={proprietarioCnpj}
                    onChange={e => setProprietarioCnpj(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="p-inputgroup">
                  <Input100px className="p-inputgroup-addon">
                    Inscrição Estadual
                  </Input100px>
                  <InputText
                    maxLength={14}
                    value={proprietarioIe}
                    onChange={e => setProprietarioIe(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="row form-elo">
              <div className="col-3">
                <div className="p-inputgroup">
                  <Input100px className="p-inputgroup-addon">
                    RNTRC
                  </Input100px>
                  <InputText
                    maxLength={7}
                    value={proprietarioRntrc}
                    onChange={e => setProprietarioRntrc(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="p-inputgroup">
                  <Input100px className="p-inputgroup-addon">
                    UF
                  </Input100px>
                  <Dropdown
                    options={listaUf}
                    value={proprietarioUf}
                    emptyMessage="Nenhum registro a ser exibido"
                    onChange={e => setProprietarioUf(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-6">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Tipo Proprietário
                  </Input155px>
                  <Dropdown
                    options={listaMdfeTipoProprietario}
                    value={proprietarioTipo}
                    emptyMessage="Nenhum registro a ser exibido"
                    onChange={(e) => setProprietarioTipo(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Expecificações">
            <div className="row form-elo">
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Chassi
                  </Input155px>
                  <InputText
                    maxLength={17}
                    value={chassi}
                    onChange={handleChassiChange}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Marcação Chassi
                  </Input155px>
                  <Dropdown
                    options={listaVin}
                    value={vin}
                    emptyMessage="Nenhum registro a ser exibido"
                    onChange={e => setVin(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Número Série
                  </Input155px>
                  <InputText
                    maxLength={9}
                    value={nSerie}
                    onChange={e => setNSerie(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="row form-elo">
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Número Motor
                  </Input155px>
                  <InputText
                    maxLength={21}
                    value={nMotor}
                    onChange={e => setNMotor(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Cilindradas em cm<sup>3</sup>
                  </Input155px>
                  <InputNumber
                    mode="decimal"
                    inputId="minmaxfraction"
                    minFractionDigits={0}
                    maxFractionDigits={0}
                    min={0}
                    max={9999}
                    value={cilindradas}
                    onValueChange={e => setCilindradas(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Potência CV
                  </Input155px>
                  <InputNumber
                    mode="decimal"
                    inputId="minmaxfraction"
                    minFractionDigits={0}
                    maxFractionDigits={0}
                    min={0}
                    max={9999}
                    value={potenciaCv}
                    onValueChange={e => setPotenciaCv(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="row form-elo">
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Capac Máx Tração
                  </Input155px>
                  <InputNumber
                    mode="decimal"
                    inputId="minmaxfraction"
                    maxFractionDigits={4}
                    value={cmt}
                    min={0}
                    max={999999999}
                    onValueChange={e => setCmt(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Distância eixos
                  </Input155px>
                  <InputNumber
                    mode="decimal"
                    inputId="minmaxfraction"
                    minFractionDigits={0}
                    maxFractionDigits={0}
                    min={0}
                    max={9999}
                    value={dist}
                    onValueChange={e => setDist(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Combustível
                  </Input155px>
                  <Dropdown
                    options={listaTipoCombustivel}
                    value={tpComb}
                    emptyMessage="Nenhum registro a ser exibido"
                    onChange={e => setTpComb(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="row form-elo">
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Ano Modelo
                  </Input155px>
                  <InputNumber
                    mode="decimal"
                    inputId="minmaxfraction"
                    minFractionDigits={0}
                    maxFractionDigits={0}
                    min={1950}
                    max={3099}
                    value={anoModelo}
                    onValueChange={e => setAnoModelo(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Ano Fabricação
                  </Input155px>
                  <InputNumber
                    inputId="minmaxfraction"
                    minFractionDigits={0}
                    maxFractionDigits={0}
                    min={1900}
                    max={3000}
                    value={anoFabricacao}
                    onValueChange={e => setAnoFabricacao(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Tipo Veículo
                  </Input155px>
                  <Dropdown
                    options={listaTipoVeiculo}
                    value={tpVeic}
                    emptyMessage="Nenhum registro a ser exibido"
                    onChange={e => setTpVeic(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="row form-elo">
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Espécie Veículo
                  </Input155px>
                  <Dropdown
                    options={listaEspecieVeiculo}
                    value={espVeic}
                    emptyMessage="Nenhum registro a ser exibido"
                    onChange={e => setEspVeic(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Condição Veículo
                  </Input155px>
                  <Dropdown
                    options={listaCondicaoVeiculo}
                    value={condVeic}
                    emptyMessage="Nenhum registro a ser exibido"
                    onChange={e => setCondVeic(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Código Modelo
                  </Input155px>
                  <InputText
                    maxLength={6}
                    value={cMod}
                    onChange={e => setCMod(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="row form-elo">
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Tipo Pintura
                  </Input155px>
                  <Dropdown
                    options={listaTipoPintura}
                    value={tpPint}
                    emptyMessage="Nenhum registro a ser exibido"
                    onChange={e => setTpPint(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Cor Denatran
                  </Input155px>
                  <Dropdown
                    options={listaCodigoCorDenatran}
                    value={cCorDenatran}
                    emptyMessage="Nenhum registro a ser exibido"
                    onChange={e => setCCorDenatran(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Código da Cor
                  </Input155px>
                  <InputText
                    maxLength={4}
                    value={codigoCor}
                    onChange={e => setCodigoCor(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="row form-elo">
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Descrição da Cor
                  </Input155px>
                  <InputText
                    maxLength={20}
                    value={cor}
                    onChange={e => setCor(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Número passageiros
                  </Input155px>
                  <InputNumber
                    maxFractionDigits={0}
                    min={0}
                    max={999}
                    value={lota}
                    onValueChange={e => setLota(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Tipo Restrição
                  </Input155px>
                  <Dropdown
                    options={listaTipoRestricao}
                    value={tpRest}
                    emptyMessage="Nenhum registro a ser exibido"
                    onChange={e => setTpRest(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="row form-elo">
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Peso Bruto
                  </Input155px>
                  <InputNumber
                    mode="decimal"
                    inputId="minmaxfraction"
                    minFractionDigits={3}
                    maxFractionDigits={3}
                    value={pesoB}
                    onValueChange={e => setPesoB(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="p-inputgroup">
                  <Input155px className="p-inputgroup-addon">
                    Peso Líquido
                  </Input155px>
                  <InputNumber
                    mode="decimal"
                    inputId="minmaxfraction"
                    minFractionDigits={3}
                    maxFractionDigits={3}
                    value={pesoL}
                    onValueChange={e => setPesoL(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </TabPanel>
        </TabView>
        <div className="row form-elo">
          <div className="col-12">
            <hr />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <button
              onClick={handleSubmit}
              type="button"
              className="btn btn-success"
            >
              <i className="pi pi-check"></i>
              Salvar
            </button>
            <button
              onClick={handleCancel}
              type="button"
              className="btn btn-danger"
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Card>
    </div>
  );
}
